import React, { Component } from 'react'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'

process.env.REACT_APP_SENTRY_DSN &&
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    // tracesSampleRate: 0.5,
    environment: process.env.REACT_APP_SENTRY_ENV || ''
  })
import { Box, Heading, Image, Grommet, grommet, Stack } from 'grommet'
import { parse } from 'query-string'

import { Authenticate } from './Authenticate'
import { diversionTheme, meshTheme } from './libs/theme'
import PropTypes from 'prop-types'

import { BrowserRouter, Route, Switch, withRouter, useLocation } from 'react-router-dom'
import { PrivateRoute } from './components/Common'
import App from './App'

import axios from 'axios'
import firebase from './libs/firebase'
import Cookies from 'js-cookie'
import { AppContext, AuthContext } from './libs/context'
import { setAuthToken, setUser } from './libs/firebaseAuth'
import { MotionBox } from './components/Motion'
import { AnimatePresence } from 'framer-motion'
import { linearGradient } from './libs/color'
import { PublicApp } from './Public'
import { ClientApp } from './Client'
import { opsAPI } from './api/retail'
// import { ReceiverApp } from './ReceiverApp'
class Root extends Component {
  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route path="/public" component={PublicApp} />
          <Route path="/" render={() => <AuthRootWithRouter />} />
        </Switch>
      </BrowserRouter>
    )
  }
}
class AuthRoot extends Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  }
  listeners = []
  state = {
    authorized: false,
    tokenExpires: null,
    authUser: null,
    authToken: null,
    loading: false,
    demoMode: false,
    // receiverUserChecked: false,
    // receiverUser: null
  }
  logout = () => {
    firebase
      .auth()
      .signOut()
      .then(() => {
        firebase.analytics().logEvent('logout', { method: 'logout-button' })

        // Sign-out successful.
        // this.unsubscribe()
        // this.setUser(null)
        // this.setAuthToken(null)
      })
      .catch((error) => {
        // An error happened.
      })
  }

  setAuthToken = (user) => {
    setAuthToken(user, (token, expirationTime, claims) => {
      console.log('setAuthToken called', claims)
      // if(!user.email.endsWith('@foodmesh.ca'))
      //   this.checkDonationAppUser(user.email);
      this.setState({
        authToken: token,
        claims: claims,
        authTokenExpireAt: expirationTime,
        authorized: token ? true : false
      })
    })
  }
  setUser = (user) => {
    if (user) {
      firebase.analytics().setUserProperties({
        email: user.email,
        uid: user.uid,
        is_staff: user.email.endsWith('@foodmesh.ca')
      })
      firebase.analytics().logEvent('login', { method: user.providerData.providerId })
    }

    setUser(user, (u) => {
      this.setState({ authUser: u }, () => {
        !u && this.props.history.push('/login')
      })
    })
  }
  fetchingState = (state) => {
    this.setState({ loading: state })
  }
  componentDidMount() {
    // set token change listener
    console.log('ROOT MOUNTED...', this.props.location.search)
    const parsed = parse(this.props.location.search)

    this.setState({ demoMode: parsed.demo === 'true' })
    firebase.analytics().logEvent('app', 'loaded')
    const subscribeToken = firebase.auth().onIdTokenChanged(this.setAuthToken)
    const subscribeAuth = firebase.auth().onAuthStateChanged(this.setUser)
    this.listeners.push(subscribeToken)
    this.listeners.push(subscribeAuth)
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    const authUserChanged = prevState.authUser !== this.state.authUser
    const claimsChanged = prevState.claims !== this.state.claims
    // const receiverUserChanged = prevState.receiverUserChecked !== this.state.receiverUserChecked
    // const isValidReceiverUser = this.state.receiverUser && this.state.receiverUser.data.count > 0;
    if ((authUserChanged && this.state.authUser) || (claimsChanged && this.state.claims)) {
      // set a delay to allow token to be written to a cookie if a user is changed
      // ideally we want user to be redirected somewhere after login has succeeded
      setTimeout(() => {
        const { claims = {} } = this.state
        console.log('redirecting to home, user changed')
        console.log(this.props.history, this.props.location)
        const lastPath = this.props.history.location.pathname
        // if we are a staff member paths differ a bit
        if (claims.staff) {
          if (lastPath === '/login' || lastPath === '/') {
            this.props.history.push('/ops')
          } else {
            this.props.history.push(this.props.history.pathname)
          }
        }
        if (!claims.staff && lastPath === '/login') {
          this.props.history.push('/')
        } else {
          this.props.history.push(this.props.history.pathname)
        }

      }, 1000)
      // authContext forces a re-render so we don't need this right now
    }
  }

  unsubscribe = () => {
    console.log('Unsubscribing listeners', this.listeners)
    this.listeners.forEach((listener) => listener())
    this.listeners = []
  }
  componentWillUnmount() {
    this.unsubscribe()
  }
  setDemoMode = (value) => {
    this.setState({ demoMode: value })
  }
  // async checkDonationAppUser(email) {
  //   const receiverUser = await opsAPI.getFromRetail('receiverusers', {
  //     email: email
  //   });
  //   if (receiverUser) {
  //     this.setState({ receiverUser: receiverUser, receiverUserChecked: true })
  //   }
  // }
  render() {
    const { claims = {}, authUser, demoMode } = this.state
    const authContextValue = {
      actions: {
        logout: this.logout,
        setDemoMode: this.setDemoMode
      },
      authUser: authUser,
      claims: this.state.claims,
      demoMode: demoMode
    }
    const commonAuthProps = {
      logoutAction: this.logout,
      authUser: authUser,
      claims: claims
    }
    // const isValidReceiverUser = receiverUser && receiverUser.data.count > 0;
    return (
      <Grommet theme={demoMode ? diversionTheme : meshTheme} full>
        <AuthContext.Provider value={authContextValue}>
          <AnimatePresence inital={false}>
            <MotionBox
              background={linearGradient('mesh-accent-red', 'light-5', {
                angle: -20,
                opacityStart: 25,
                opacityFinish: 100,
                startOffset: -50,
                endOffset: 100
              })}
              variants={{
                open: { opacity: 1 },
                collapsed: { opacity: 0 }
              }}
              initial="collapsed"
              animate="open"
              exit="collapsed"
              transition={{ type: 'spring', duration: 0.7 }}
              fill
              justify="center"
              align="center"
            >
              <Switch>
                <Route
                  exact
                  path="/login"
                  render={(props) => (
                    <Authenticate {...props} demoMode={demoMode} logoutAction={this.logout} />
                  )}
                />

                {claims.staff && (
                  <>
                    <PrivateRoute
                      exact
                      path="/as_client/"
                      componentProps={commonAuthProps}
                      component={ClientApp}
                    />
                    <PrivateRoute path="/ops" componentProps={commonAuthProps} component={App} />
                  </>
                )}
                {!claims.staff && (
                  <>
                    <PrivateRoute path="/" componentProps={commonAuthProps} component={ClientApp} />
                  </>
                )}
                {/* {isValidReceiverUser && (
                  <>
                    <PrivateRoute path="/receiver-app" componentProps={{ ...commonAuthProps, receiverUser }}
                      component={ReceiverApp} />
                  </>
                )} */}
              </Switch>
            </MotionBox>
          </AnimatePresence>
        </AuthContext.Provider>
      </Grommet>
    )
  }
}
const AuthRootWithRouter = withRouter(AuthRoot)

export default Root
